const SORTABLE_ANALYTICS_FILE_FIELDS = {
  pipeline: 'pipeline',
  updatedAt: 'updatedAt',
};

export default SORTABLE_ANALYTICS_FILE_FIELDS;
